import { createAction } from 'redux-actions';
import { PapiStudioDiscountsInit } from '@wix/da-papi-types';
import { DiscountsSubsection } from '../../types/store';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';

export const initializeDiscounts = createAction(
  'STUDIO.SELLER_DISCOUNTS_INITIALIZE',
  (
    subsection: DiscountsSubsection,
    limitations: PapiStudioDiscountsInit['limitations']
  ) => ({ subsection, limitations })
);

export const fetchNextSellerDiscounts = createCallbackActionCreator(
  'FETCH_NEXT_SELLER_DISCOUNTS'
);

export const fetchNextSellerDiscountsEnded = createCallbackActionCreator(
  'FETCH_NEXT_SELLER_DISCOUNTS_ENDED'
);
